import { Promise } from '@zervant/reactcomponents'

import { ACTIONS } from '../Global/Actions'
import { Middleware } from '../Middleware'

export const NavigationLogic = Middleware.logic()
  .action(ACTIONS.NAVIGATE_ADD_MODAL, (payload, state) => {
    state.navigation.modals.push(payload)
    return Promise.resolve(state)
  })
  .action(ACTIONS.NAVIGATE_REMOVE_MODAL, (payload, state, utils) => {
    state.navigation.modals = state.navigation.modals.filter((modal, index) => {
      return index !== payload.index
    })

    if (payload.action) {
      return new Promise((resolve, reject) => {
        utils.now(ACTIONS[payload.action](payload.payload)).then((state) => {
          resolve(state)
        })
      })
    } else {
      return Promise.resolve(state)
    }
  })
  .action(ACTIONS.NAVIGATE, (payload, state, utils) => {
    if (state.draft && state.draft.isDirty && payload.path && payload.path !== '/reactInvoice') {
      return new Promise((resolve, reject) => {
        utils
          ?.now(
            ACTIONS.NAVIGATE_ADD_MODAL({
              component: 'LeaveUnsavedModal',
              props: {
                payload,
                titleKey: 'invoice.approvalConfirmation.header',
                bodyKey: 'invoice.DataLostWarning',
              },
            }),
          )
          .then(resolve)
      })
    } else {
      let path = ['']
      if (state.navigation.path) {
        path = state.navigation.path.split('/')
      }
      if (payload.path) {
        path = payload.path.split('/')
      } else if (payload.app.mod) {
        path = ['', payload.app.mod]
        if (payload.app.view) {
          path.push(payload.app.view)
        }
      }

      state.navigation.path = path.join('/')

      if (payload.app) {
        state.navigation.app = { ...payload.app }
      }

      state.navigation.app.mod = path[1]
      if (path.length > 2 && path[2] !== '') {
        state.navigation.app.view = path[2]
      }

      return state.navigation
    }
  })
